/* eslint-disable react/prop-types */
import React, { memo, useCallback } from 'react';
import { MagicPosterPanel } from '../../ChatDSTemplate/components/ChatMagicPoster';
import type { ChatDSTemplateActionsListProps } from '../../ChatDSTemplate/type';

/** 从 ChatDSTemplateActionsListProps 中提取分享场景所需的类型 */
type IChatMagicPosterShareProps = Pick<ChatDSTemplateActionsListProps, 'dsReport' | 'sessionId' | 'handleUpdateDsReport' | 'data'>;

/**
 * 分享场景下的魔法海报只读包装组件
 * 职责：从分享场景的 props 中适配出 MagicPosterPanel 所需的 props，固定传入 readonly={true}
 * 不复制任何渲染逻辑，仅做数据适配
 */
const ChatMagicPosterShare: React.FC<IChatMagicPosterShareProps> = memo(({
  dsReport,
  sessionId,
  handleUpdateDsReport,
  data
}) => {
  // 分享场景下不需要发起新对话，提供空函数
  const noop = useCallback(() => {}, []);
  return (
    <MagicPosterPanel
      handleUpdateDsReport={handleUpdateDsReport}
      startNewConversation={noop}
      conversations={data?.messages}
      dsReport={dsReport}
      sessionId={sessionId as string}
      streamingState=""
      readonly={true}
      showCloseButton={true}
    />
  );
});

ChatMagicPosterShare.displayName = 'ChatMagicPosterShare';

export default ChatMagicPosterShare;
